import React from "react";
import { DatasetDataInfoResponse } from "api/model/dataset/DatasetDataInfoResponse";
import useTimerThreshold from "hooks/useTimerThreshold";
import UniversalTableDatasetButtonComponent from "./UniversalTableDatasetButtonComponent";
import { DatasetButtonWrapperProps } from "./UniversalDatasetTableTypes";

const UniversalTableDatasetButtonWrapper = ({
  datasetId,
  columnIndex,
  rowData,
  dataset,
  data,
  time,
  compactMode,
  maxAge,
}: DatasetButtonWrapperProps & { dataset: DatasetDataInfoResponse }) => {
  const { isExpired } = useTimerThreshold(maxAge, time?.getTime?.() ?? 0);

  return (
    <UniversalTableDatasetButtonComponent
      id={datasetId ?? ""}
      columnIndex={columnIndex}
      rowData={rowData}
      compactMode={compactMode}
      dataset={dataset}
      data={data}
      time={time}
      isExpired={isExpired}
    />
  );
};

export default UniversalTableDatasetButtonWrapper;
